import palette from 'components/palette'
import transparentize from 'polished/lib/color/transparentize'
import styled from 'styled-components'

const color = transparentize(0.3, palette.blue600)

const InlineSpinner = styled.div`
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;

  :after {
    content: ' ';
    display: block;
    width: 1.5rem;
    height: 1.5rem;
    margin: 0;
    border-radius: 50%;
    border: 3px solid ${color};
    border-color: ${color} transparent;
    border-top: 0;
    animation: inlinespinner-spin 1.2s linear infinite;
  }

  @keyframes inlinespinner-spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

export default InlineSpinner
